import React from 'react';
import { Autocomplete, FormControl, Typography, TextField, Stack, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const MyAutocompleteComponent = ({
  userOptions,
  selectedOptions,
  inputValue,
  handleInput,
  handleChange,
  handleClear,
  setOpen,
  backgroundColor,
  width
}) => {
  return (
    <FormControl variant="outlined">
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}></Typography>
      <Autocomplete
        options={userOptions || []}
        multiple
        getOptionLabel={(option) => option?.UserName} // Only display the UserName in the options
        isOptionEqualToValue={(option, value) => option?.UserName === value?.UserName}
        freeSolo
        value={selectedOptions}
        onInputChange={handleInput}
        inputValue={inputValue}
        onClose={setOpen == null ? null : () => setOpen(false)}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={'@Username'}
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                padding: '0px',
                width: width ? width : '160px',
                height: '32px',
                fontSize: '14px',
                background: backgroundColor != null ? backgroundColor : '#fff'
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {selectedOptions?.length > 0 && (
                    <Stack
                      sx={{
                        backgroundColor: '#AAD2E2',
                        padding: '2px 4px',
                        borderRadius: '4px',
                        flexDirection: 'row',
                        gap: '2px',
                        alignItems: 'center'
                      }}>
                      <Typography
                        sx={{
                          fontSize: '10px',
                          lineHeight: '14px',
                          color: '#000000'
                        }}>{`+${selectedOptions?.length}`}</Typography>
                      <IconButton
                        aria-label="Clear filter"
                        size="small"
                        sx={{ padding: 0 }}
                        onClick={handleClear}>
                        <CloseIcon
                          sx={{
                            color: '#000000',
                            width: '14px',
                            height: '14px'
                          }}
                        />
                      </IconButton>
                    </Stack>
                  )}
                </>
              ),
              startAdornment: null
            }}
            value=""
          />
        )}
        sx={{
          '& .MuiAutocomplete-tag': {
            width: width ? width : '160px', // Ensure that tags do not exceed the width of the container
            overflow: 'hidden', // Hide overflow
            textOverflow: 'ellipsis', // Show ellipsis for longer tag names
            whiteSpace: 'nowrap', // Prevent tags from wrapping
            flexWrap: 'nowrap'
          },
          '& .MuiAutocomplete-inputRoot': {
            display: 'flex', // Display tags and input inline
            flexWrap: 'nowrap' // Ensure they don’t wrap
          }
        }}
      />
    </FormControl>
  );
};

export default MyAutocompleteComponent;
